import { render } from "./Review.vue?vue&type=template&id=7600c38e"
import script from "./Review.vue?vue&type=script&lang=ts"
export * from "./Review.vue?vue&type=script&lang=ts"
script.render = render

export default script